export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6188.8fafe439.jpg";